export default __webpack_public_path__ + "static/ProValue_5@mob-b95f47a61eb5d4d128fd7f8d6ac44c14.png";